import { render, staticRenderFns } from "./firstScreen.vue?vue&type=template&id=d7b5180e&"
import script from "./firstScreen.vue?vue&type=script&lang=js&"
export * from "./firstScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports